export enum CopyState {
  Error = 'ERROR',
  Clipboard = 'CLIPBOARD',
  ClipboardData = 'CLIPBOARDDATA',
}
